<template>
  <div class="flex items-center h-12 shadow-md">
    <span @click="closeDrawer(true)">
      <ElIcon class="ml-3 text-2xl text-gray-600"><MenuIcon> </MenuIcon> </ElIcon>
    </span>
    <div class="flex items-center justify-center flex-1">{{ route.meta.title || '金桔打卡记账' }}</div>
    <UserMenu></UserMenu>
  </div>
  <AppView></AppView>

  <ElDrawer
    v-model="appStore.mobileMenuDrawer"
    append-to-body
    class="w-[230px] mobile-menu"
    title="金桔记账"
    direction="ltr"
    :before-close="() => closeDrawer(false)"
  >
    <Menu></Menu>
  </ElDrawer>
</template>

<script lang="ts">
import { Menu as MenuIcon } from '@element-plus/icons-vue';
import { ElDrawer, ElIcon } from 'element-plus';
import { defineComponent, reactive, toRefs } from 'vue';
import Menu from './Menu.vue';
import { useAppStore } from '@/store/modules/app';
import AppView from './AppView.vue';
import { useRoute } from 'vue-router';
import UserMenu from './userMenu.vue';

export default defineComponent({
  components: {
    UserMenu,
    ElDrawer,
    ElIcon,
    MenuIcon,
    Menu,
    AppView,
  },
  setup() {
    const _data = reactive({
      drawer: false,
    });
    const appStore = useAppStore();
    const route = useRoute();
    const _methods = {
      closeDrawer(val: boolean) {
        appStore.mobileMenuDrawer = val;
      },
    };
    return {
      ...toRefs(_data),
      ..._methods,
      appStore,
      route,
    };
  },
});
</script>

<style lang="less">
.mobile-menu {
  margin-bottom: 20px;
  .el-drawer__header {
    margin-bottom: 0;
  }
  .el-drawer__body {
    padding: 0;
  }
}
</style>
